import { LEGACY_TYPOGRAPHY_COLOR_MAP } from "../constants/legacy-typography-color-map"
import { type SbBlokTypography, type SbLegacyTypographyColor } from "../types"

function isLegacyColor(
    color: NonNullable<SbBlokTypography["color"]>
): color is SbLegacyTypographyColor {
    return Object.keys(LEGACY_TYPOGRAPHY_COLOR_MAP).includes(color)
}

export function getTypographyColor(color: NonNullable<SbBlokTypography["color"]>) {
    if (isLegacyColor(color)) {
        return LEGACY_TYPOGRAPHY_COLOR_MAP[color]
    }

    return color
}
